import React, { Component, Fragment } from 'react';
import axios from "axios";
import { Input, Row, Col, FormFeedback, Label, Card, CardTitle, CardBody, Button } from 'reactstrap';

import api from '../../../api/api';

import Modal from "./Modal"
import ModalCuenta from "./ModalCuenta";
import { format } from '../../../functions/functions';

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"

import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import moment from 'moment';

class MovimientosCaja extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => d.fecha ? moment(d.fecha).format('DD/MM/YYYY') : '',
                    className: "text-center",
                    show: true,
                    width: 100,
                    filterable: false,
                    exportWidth: "55",
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Caja",
                    id: "caja__nombre",
                    accessor: d => d.caja__nombre ? d.caja__nombre : '',
                    show: true,
                    filterable: false,
                    exportWidth: "80",
                },
                {
                    Header: "Cuenta",
                    id: "cuenta",
                    // accessor: d => d.cuenta ? d.cuenta.nombre : '',
                    show: false,
                    filterable: false,
                    private: true,
                },
                {
                    Header: "Cuenta",
                    id: "cuenta__nombre",
                    accessor: d => d.cuenta__nombre ? d.cuenta__nombre : '',
                    show: true,
                    exportWidth: "80",
                    filterable: false,
                    Filter: ({ filter, onChange }) =>
                            <ParadigmaAsyncSeeker
                                clearable
                                url={api.caja.cuentas}
                                value={(filter && filter.value) ? filter.value.input : ""}
                                valueField={'nombre'}
                                onChange={data => (data) ? (onChange({lookup: null, input: data.nombre})): ((filter) ? onChange('') : null)}
                            />
                },
                {
                    Header: "Compradores",
                    id: "clientes",
                    accessor: d => d.clientes ? d.clientes : '', 
                    show: true,
                    filterable: false,
                    exportWidth: "100",
                },
                {
                    Header: "Loteo",
                    id: "loteoNombre",
                    accessor: d => d.loteoNombre ? d.loteoNombre : '', 
                    show: true,
                    filterable: false,
                    exportWidth: "70",
                },
                {
                    Header: "Lote",
                    id: "loteNombre",
                    accessor: d => d.loteNombre ? d.loteNombre : '', 
                    show: true,
                    filterable: false,
                    exportWidth: "30",
                },
                {
                    // (Nota) La moneda de la cuota depende de este campo.
                    Header: "Moneda Operacion",
                    id: "moneda_operacion",
                    filterable: false,
                    private: true,
                    show: false,
                },
                {
                    Header: "Monto Cuota",
                    id: "montoCuota",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => d.montoCuota ? 
                        `${d.moneda_operacion.simbolo} ${format(d.montoCuota)}` : 
                        `${d.moneda_operacion.simbolo} ${format("0.0")}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Interés Cuota",
                    id: "interesCuota",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => d.interesCuota ? 
                        `${d.moneda_operacion.simbolo} ${format(d.interesCuota)}` : 
                        `${d.moneda_operacion.simbolo} ${format("0.0")}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Moneda Pesos",
                    id: "moneda_pesos",
                    filterable: false,
                    private: true,
                    show: false,
                },
                {
                    Header: "Ingreso Pesos",
                    id: "ingreso_pesos",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => `${d.moneda_pesos.simbolo} ${format(d.ingreso_pesos)}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Egreso Pesos",
                    id: "egreso_pesos",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => `${d.moneda_pesos.simbolo} ${format(d.egreso_pesos)}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Moneda Dolares",
                    id: "moneda_dolares",
                    filterable: false,
                    private: true,
                    show: false,
                },
                {
                    Header: "Ingreso Dólares",
                    id: "ingreso_dolares",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => `${d.moneda_dolares.simbolo} ${format(d.ingreso_dolares)}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Egreso Dólares",
                    id: "egreso_dolares",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => `${d.moneda_dolares.simbolo} ${format(d.egreso_dolares)}`,
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
            ],
            filtros: {
                desde: moment(),
                hasta: moment(),
                caja_id: null,
                cuenta_id: null,
                tipoDefecto: null,
            },
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { desde, hasta, caja_id, cuenta_id, tipoDefecto } = this.state.filtros;
        let outerFilter = [];

        if (desde && hasta) {
            outerFilter.push({
                id: 'fecha',
                value: {
                    lookup: 'date__range',
                    input: `${moment(desde).format('YYYY-MM-DD')},${moment(hasta).format('YYYY-MM-DD')}`,
                }
            });
        }

        if (caja_id!=null) {
            outerFilter.push({
                id: 'caja_id',
                value: {
                    lookup: 'exact',
                    input: caja_id,
                }
            })
        }

        if (cuenta_id!=null) {
            outerFilter.push({
                id: 'cuenta_id',
                value: {
                    lookup: 'exact',
                    input: cuenta_id,
                }
            })
        }
        
        return (
            <Fragment>
                <Row className={'mt-1'}>
                    <Col className="col-12">
                        <Card body className="ui-filter-panel p-0 mb-3">
                            <CardTitle className="text-center mb-0">
                                Filtros
                            </CardTitle>
                            <CardBody>
                                <Row>
                                    <Col className="col-12 col-md-4 col-lg-4 mr-2">
                                        <ParadigmaLabeledInput
                                            label="Período"
                                            md={[3, 9]}
                                            inputComponent={
                                                <Row>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 mb-0 mb-md-1 mb-xl-0 pr-1">
                                                        <ParadigmaDatePicker fieldName={"fechaInicio"}
                                                            datetime={false}
                                                            placeholder={"Desde"}
                                                            icon={"fa fa-calendar"}
                                                            value={desde}
                                                            className={'repFechaInp'}
                                                            onChange={data => 
                                                                this.setState(prevState => ({
                                                                    filtros: {
                                                                        ...prevState.filtros,
                                                                        desde: data
                                                                    }
                                                            }))}
                                                        />
                                                    </Col>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 pl-1">
                                                        <ParadigmaDatePicker fieldName={"fechaFin"}
                                                            datetime={false}
                                                            placeholder={"Hasta"}
                                                            icon={"fa fa-calendar"}
                                                            value={hasta}
                                                            className={'repFechaInp fhasta'}
                                                            onChange={data => 
                                                                this.setState(prevState => ({
                                                                    filtros: {
                                                                        ...prevState.filtros,
                                                                        hasta: data
                                                                    }
                                                            }))}
                                                        />
                                                    </Col>
                                                </Row>
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4 col-lg-3">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Caja"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    url={api.caja.caja}
                                                    clearable={true}
                                                    value={caja_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    onChange={data => {
                                                        this.setState(prevState => ({
                                                            filtros: {
                                                                ...prevState.filtros,
                                                                caja_id: (data) ? (data.id) : (null),
                                                            }
                                                    }))}}
                                                />
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4 col-lg-3">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Cuenta"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    url={api.caja.cuentas}
                                                    clearable={true}
                                                    value={cuenta_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    onChange={data => {
                                                        this.setState(prevState => ({
                                                            filtros: {
                                                                ...prevState.filtros,
                                                                cuenta_id: (data) ? (data.id) : (null),
                                                                tipoDefecto: (data) ? (data.tipoDefecto) : (null),
                                                            }
                                                    }))}}
                                                />
                                            }
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className={'col-12'}>
                        <ParadigmaTable
                            buttons={[
                                {
                                    create: true,
                                    component: (props) => <Modal {...props} action="CREATE" caja_id={caja_id} cuenta_id={cuenta_id} tipoDefecto={tipoDefecto}/>,
                                    permission: 'caja_movimientoscaja_new',
                                },
                                {
                                    edit: true,
                                    component: (props) => <Modal {...props} action="EDIT" />,
                                    permission: 'caja_movimientoscaja_edit',
                                },
                                {
                                    edit: true,
                                    component: (props) => <Modal {...props} action="DETAIL" />,
                                    permission: 'caja_movimientoscaja_detail',
                                },
                                {
                                    edit: true,
                                    component: (props) => <Modal {...props} action="DELETE" />,
                                    permission: 'caja_movimientoscaja_delete',
                                },
                                {
                                    edit: true,
                                    component: (props) => <ModalCuenta {...props} action="EDIT" />,
                                    permission: 'caja_movimientoscaja_cuentas',
                                },
                            ]}
                            apiUrl={api.caja.movimientosCaja}
                            columns={this.state.columns}
                            exportUrl={api.caja.movimientosCaja}
                            outerFilter={[...outerFilter,]}
                            title={"Movimientos de Caja"}
                        />
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export default MovimientosCaja;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosCaja/MovimientosCaja.js